import React from 'react';
import { Section } from './ui/Section';
import { Gift } from 'lucide-react';
const bonos = [{
  icon: '🎮',
  title: 'BONO 1 — BANCO DE 50 JUEGOS PREACROBÁTICOS RESUELTOS',
  desc: 'Juegos listos para iniciación y clases con niños',
  value: '$12.000'
}, {
  icon: '📅',
  title: 'BONO 2 — CALENDARIO DE TEMPORADA RESUELTO',
  desc: 'Tu año completo organizado semana a semana',
  value: '$10.000'
}, {
  icon: '📊',
  title: 'BONO 3 — FICHAS DE EVALUACIÓN Y SEGUIMIENTO',
  desc: 'Evaluá elementos, niveles y progresión de cada alumno',
  value: '$9.000'
}, {
  icon: '🎵',
  title: 'BONO 4 — GUÍA DE MÚSICA PARA GIMNASIA ARTÍSTICA',
  desc: 'Selección musical para suelo y coreografías completas',
  value: '$9.000'
}, {
  icon: '📩',
  title: 'BONO 5 — KIT DE COMUNICACIÓN PARA FAMILIAS',
  desc: 'Modelos de informes de progreso listos para enviar',
  value: '$10.000'
}, {
  icon: '🥗',
  title: 'BONO 6 — MINI GUÍA DE NUTRICIÓN PARA DEPORTISTAS',
  desc: 'Alimentación práctica para niños y jóvenes gimnastas',
  value: '$8.000'
}];
export function BonosSection() {
  return <Section className="bg-navy-800 border-y border-navy-700" data-id="element-18">
      <div className="text-center mb-6 md:mb-16" data-id="element-19">
        <div className="inline-flex items-center justify-center space-x-1.5 sm:space-x-2 bg-magenta-500/10 text-magenta-400 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full font-bold text-xs sm:text-sm mb-3 md:mb-6 border border-magenta-500/20" data-id="element-20">
          <Gift className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-21" />
          <span data-id="element-22">Incluidos en todas las ofertas — sin costo extra</span>
        </div>
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white" data-id="element-23">
          MÁS LOS 6 BONOS ESTRATÉGICOS
        </h2>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-6 mb-6 md:mb-12" data-id="element-24">
        {bonos.map((bono, i) => <div key={i} className="bg-navy-900 border border-navy-700 rounded-xl md:rounded-2xl p-3 md:p-6 relative overflow-hidden group" data-id="element-25">
            <div className="absolute top-0 right-0 bg-magenta-500 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 md:px-3 md:py-1 rounded-bl-lg z-10" data-id="element-26">
              GRATIS
            </div>

            <div className="text-xl md:text-3xl mb-2 md:mb-4" data-id="element-27">{bono.icon}</div>
            <h3 className="text-xs md:text-lg font-bold text-white mb-1 md:mb-2 leading-tight pr-6 md:pr-8" data-id="element-28">
              {bono.title}
            </h3>
            <p className="text-gray-400 text-[10px] md:text-sm mb-3 md:mb-6" data-id="element-29">
              "{bono.desc}"
            </p>

            <div className="mt-auto pt-2 md:pt-4 border-t border-navy-800 flex items-center justify-between" data-id="element-30">
              <span className="text-gray-500 text-[10px] md:text-sm" data-id="element-31">
                <span className="line-through" data-id="element-32">{bono.value}</span>
              </span>
              <span className="text-magenta-400 font-bold text-xs md:text-base" data-id="element-33">
                GRATIS
              </span>
            </div>
          </div>)}
      </div>

      <div className="bg-gradient-to-r from-navy-900 to-navy-800 border border-gold-500/30 rounded-xl md:rounded-2xl p-4 md:p-8 text-center max-w-2xl mx-auto" data-id="element-34">
        <p className="text-gray-400 mb-1 text-xs md:text-base" data-id="element-35">
          Valor total de los 6 bonos:{' '}
          <span className="line-through text-gray-500" data-id="element-36">$58.000</span>
        </p>
        <p className="text-xl md:text-3xl font-black text-gold-400 uppercase tracking-wide" data-id="element-37">
          GRATIS — Incluidos siempre
        </p>
      </div>
    </Section>;
}